<mat-sidenav-container class="application-container">
    <mat-sidenav mode="side" opened>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <p><strong>Progress</strong></p>
            <mat-progress-bar
                [color]="'primary'"
                [mode]="'determinate'"
                [value]="(activeStep)*100/(steps.length-1)">
            </mat-progress-bar>
            <!-- don't include the comfirmation step in length -->

            <mat-list>
              <mat-list-item *ngFor="let step of steps;let i = index;" class="{{step.id}}"
                              [ngClass]="[activeStep === i ? 'active' : '', isStepComplete(i) ? 'complete' : '']">
                {{step.name}}<i class="material-icons md-18 icon-position-right">{{getStepIcon(i)}}</i>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <h2>{{wizardName}}</h2>
          </div>
        </div>
        <form (ngSubmit)="submitApplication()" class="form__wizard" autocomplete="off" novalidate>
            <div *ngFor="let step of steps;let stepIdx = index; let isLastStep=last;" class="application-step" [ngClass]="[activeStep === stepIdx ? 'active' : '']">
              <div class="row">
              <div [ngClass]="widget.class" *ngFor="let widget of step.widgets">

                <app-originator-broker
                  *ngIf="widget.name === 'app-originator-broker'"
                  [opts]="widget.opts"
                  [productCategory]="loanPurposeType"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  (brokerDetails)="handleBrokerDetailsChange($event)"
                ></app-originator-broker>

                <app-customer-details
                  *ngIf="widget.name === 'app-customer-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                ></app-customer-details>

                <app-quote-details
                  *ngIf="widget.name === 'app-quote-details'"
                  [opts]="widget.opts"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  [broker]="brokerDetails"
                  ></app-quote-details>

                <app-rate
                  *ngIf="widget.name === 'app-rate'"
                  [opts]="widget.opts"
                  [originator]="originatorDetails"
                  [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                  ></app-rate>
              </div>
              </div>
              <div class="row">
                <div class="col-sm-2"></div>
                <div class="col-sm-8 d-flex flex-column flex-grow">
                  <button mat-raised-button class="fmc-button-primary" color="'primary'" mode="indeterminate" type="submit" [disabled]="isLoading">
                    <strong>Calculate Quote</strong>
                    <mat-spinner class="calculate-loader" matSuffix [diameter]="20" [strokeWidth]="3" *ngIf="isLoading"></mat-spinner>
                  </button>
                </div>
              </div>
              <div class="row" [hidden]="!isCalculated">
              <!-- <div class="row"> -->
                <div [ngClass]="widget.class" *ngFor="let widget of step.widgets">
                  <app-quote-results
                    *ngIf="widget.name === 'app-quote-results'"
                    [opts]="widget.opts"
                    [formGroup]="baseform.get('step-'+stepIdx).get(widget.name)"
                    [quoteData]="quoteData"
                    [isPersonal]="isPersonal"
                  ></app-quote-results>
                </div>
              </div>
            </div>
        </form>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
